




































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'MemberForm'
  vue:  
    props: ['item']

    data: ->
      member_note: null
      super_note: null

    methods:
      hiAddMemberNote: ->
        return if !@member_note.length
        @item.new_member_notes.push @member_note
        @member_note = ''

      hiAddSuperNote: ->
        return if !@super_note.length
        @item.new_super_notes.push @super_note
        @super_note = ''

export default VueOptions.vue settings
